"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgreementLayout = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./AgreementLayout.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AgreementLayout = _ref => {
  let {
    title,
    agreement,
    controls
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['container'], styles[`container--${deviceType}`])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, title), agreement, /*#__PURE__*/React.createElement("div", {
    className: styles['controls']
  }, controls.map((Component, index) => /*#__PURE__*/React.createElement("div", {
    key: `controls_${index}`,
    className: styles['controls-row']
  }, Component))));
};
exports.AgreementLayout = AgreementLayout;